/*import { useState, useEffect } from "react";
import client from "../api/client";

const NS_SCALE = { Dysregulated: 1, Anxious: 2, Neutral: 3, Grounded: 4, Regulated: 5 };

function regulationDeltaLabel(delta) {
  if (delta >= 2) return "Strong positive shift";
  if (delta >= 1) return "Positive shift";
  if (delta > 0) return "Slight improvement";
  if (delta === 0) return "No change";
  if (delta >= -1) return "Slight decline";
  return "Significant decline";
}

function moodDeltaLabel(delta) {
  if (delta >= 2) return "Strong improvement";
  if (delta >= 1) return "Improved";
  if (delta > 0) return "Slight improvement";
  if (delta === 0) return "No change";
  if (delta >= -1) return "Slight decline";
  return "Significant decline";
}

function intentionMetLabel(val) {
  const labels = { 1: "Not at all", 2: "Slightly", 3: "Somewhat", 4: "Mostly", 5: "Fully" };
  return labels[parseInt(val)] || "";
}

function CollapsiblePills({ title, open: defaultOpen, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{
      background: "rgba(255,255,255,0.03)",
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "10px",
      marginBottom: "12px",
      overflow: "hidden"
    }}>
      <div
        onClick={() => setOpen(prev => !prev)}
        style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          padding: "10px 14px", cursor: "pointer", userSelect: "none"
        }}
      >
        <span style={{ fontSize: "11px", letterSpacing: "1.5px", textTransform: "uppercase", color: "#7dd3e8", opacity: 0.8 }}>
          ✦ {title}
        </span>
        <span style={{
          fontSize: "10px", opacity: 0.4,
          transform: open ? "rotate(0deg)" : "rotate(-90deg)",
          transition: "transform 0.2s", display: "inline-block"
        }}>▼</span>
      </div>
      {open && (
        <div style={{ padding: "0 14px 12px", display: "flex", flexDirection: "column", gap: "8px" }}>
          {children}
        </div>
      )}
    </div>
  );
}

// Moon phase SVG illustrations
function MoonIllustration({ phase }) {
  const defs = (
    <defs>
      <radialGradient id="moonGrad" cx="40%" cy="35%" r="60%">
        <stop offset="0%" stopColor="#fff8e0"/>
        <stop offset="40%" stopColor="#f0d878"/>
        <stop offset="100%" stopColor="#c8a840"/>
      </radialGradient>
      <radialGradient id="crater1" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="rgba(0,0,0,0.15)"/>
        <stop offset="100%" stopColor="rgba(0,0,0,0)"/>
      </radialGradient>
      <radialGradient id="darkSide" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#0d1628"/>
        <stop offset="100%" stopColor="#0a1020"/>
      </radialGradient>
    </defs>
  );

  const craters = (clipId) => (
    <g clipPath={`url(#${clipId})`}>
      <circle cx="58" cy="35" r="6" fill="url(#crater1)"/>
      <circle cx="42" cy="55" r="4" fill="url(#crater1)"/>
      <circle cx="65" cy="58" r="3" fill="url(#crater1)"/>
      <circle cx="50" cy="70" r="5" fill="url(#crater1)"/>
      <circle cx="35" cy="40" r="3" fill="url(#crater1)"/>
    </g>
  );

  const glowStyle = {
    filter: "drop-shadow(0 0 18px rgba(255, 220, 120, 0.35)) drop-shadow(0 0 40px rgba(255, 200, 80, 0.15))",
    animation: "moonGlow 4s ease-in-out infinite alternate"
  };

  const darkGlowStyle = {
    filter: "drop-shadow(0 0 8px rgba(125, 211, 232, 0.1))",
  };

  const svgProps = { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%" };

  switch (phase) {
    case 'New Moon':
      return (
        <svg {...svgProps} style={darkGlowStyle}>
          {defs}
          <circle cx="50" cy="50" r="45" fill="url(#darkSide)"/>
          <circle cx="50" cy="50" r="45" fill="none" stroke="rgba(125,211,232,0.15)" strokeWidth="0.5"/>
        </svg>
      );
    case 'Waxing Crescent':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs>
            <clipPath id="wcClip">
              <path d="M50,5 A45,45 0 1,1 50,95 Q20,75 20,50 Q20,25 50,5 Z"/>
            </clipPath>
          </defs>
          <circle cx="50" cy="50" r="45" fill="#0d1628"/>
          <path d="M50,5 A45,45 0 1,1 50,95 Q20,75 20,50 Q20,25 50,5 Z" fill="url(#moonGrad)"/>
          {craters("wcClip")}
        </svg>
      );
    case 'First Quarter':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs>
            <clipPath id="fqClip"><path d="M50,5 A45,45 0 0,1 50,95 L50,5 Z"/></clipPath>
          </defs>
          <circle cx="50" cy="50" r="45" fill="#0d1628"/>
          <path d="M50,5 A45,45 0 0,1 50,95 L50,5 Z" fill="url(#moonGrad)"/>
          {craters("fqClip")}
        </svg>
      );
    case 'Waxing Gibbous':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs>
            <clipPath id="wgClip">
              <path d="M50,5 A45,45 0 1,1 50,95 Q30,75 30,50 Q30,25 50,5 Z"/>
            </clipPath>
          </defs>
          <circle cx="50" cy="50" r="45" fill="#0d1628"/>
          <path d="M50,5 A45,45 0 1,1 50,95 Q30,75 30,50 Q30,25 50,5 Z" fill="url(#moonGrad)"/>
          {craters("wgClip")}
        </svg>
      );
    case 'Full Moon':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs>
            <clipPath id="fmClip"><circle cx="50" cy="50" r="45"/></clipPath>
          </defs>
          <circle cx="50" cy="50" r="45" fill="url(#moonGrad)"/>
          {craters("fmClip")}
        </svg>
      );
    case 'Waning Gibbous':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs>
            <clipPath id="wanGibClip">
              <path d="M50,5 A45,45 0 1,0 50,95 Q70,75 70,50 Q70,25 50,5 Z"/>
            </clipPath>
          </defs>
          <circle cx="50" cy="50" r="45" fill="#0d1628"/>
          <path d="M50,5 A45,45 0 1,0 50,95 Q70,75 70,50 Q70,25 50,5 Z" fill="url(#moonGrad)"/>
          {craters("wanGibClip")}
        </svg>
      );
    case 'Last Quarter':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs>
            <clipPath id="lqClip"><path d="M50,5 A45,45 0 0,0 50,95 L50,5 Z"/></clipPath>
          </defs>
          <circle cx="50" cy="50" r="45" fill="#0d1628"/>
          <path d="M50,5 A45,45 0 0,0 50,95 L50,5 Z" fill="url(#moonGrad)"/>
          {craters("lqClip")}
        </svg>
      );
    case 'Waning Crescent':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs>
            <clipPath id="wanCresClip">
              <path d="M50,5 A45,45 0 1,0 50,95 Q80,75 80,50 Q80,25 50,5 Z"/>
            </clipPath>
          </defs>
          <circle cx="50" cy="50" r="45" fill="#0d1628"/>
          <path d="M50,5 A45,45 0 1,0 50,95 Q80,75 80,50 Q80,25 50,5 Z" fill="url(#moonGrad)"/>
          {craters("wanCresClip")}
        </svg>
      );
    default:
      return null;
  }
}

function MoonCard({ sessionDate }) {
  const [moonData, setMoonData] = useState(null);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (!sessionDate) return;
    client.get('/moon', { params: { date: sessionDate } })
      .then(res => setMoonData(res.data))
      .catch(() => setMoonData(null));
  }, [sessionDate]);

  if (!moonData) return null;

  const { phaseName, illumination, lunarDay, season, insight } = moonData;

  const seasonEmoji = { Spring: "🌱", Summer: "☀️", Autumn: "🍂", Winter: "❄️" };

  return (
    <div style={{
      background: "linear-gradient(160deg, #0d1f3a 0%, #0a1628 50%, #0d1a2e 100%)",
      border: "1px solid rgba(125, 211, 232, 0.15)",
      borderRadius: "16px",
      overflow: "hidden",
      marginBottom: "16px",
      position: "relative"
    }}>
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden" }}>
        {Array.from({ length: 28 }).map((_, i) => (
          <div key={i} style={{
            position: "absolute",
            width: `${Math.random() * 1.5 + 0.5}px`,
            height: `${Math.random() * 1.5 + 0.5}px`,
            borderRadius: "50%",
            background: "white",
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            opacity: Math.random() * 0.5 + 0.1,
          }}/>
        ))}
      </div>

      <div
        onClick={() => setOpen(prev => !prev)}
        style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          padding: "12px 20px", cursor: "pointer", userSelect: "none",
          position: "relative"
        }}
      >
        <span style={{ fontSize: "11px", letterSpacing: "1.5px", textTransform: "uppercase", color: "#7dd3e8", opacity: 0.8 }}>
          ✦ Celestial Context
        </span>
        <span style={{
          fontSize: "10px", opacity: 0.4,
          transform: open ? "rotate(0deg)" : "rotate(-90deg)",
          transition: "transform 0.2s", display: "inline-block"
        }}>▼</span>
      </div>

      {open && (
        <>
          <div style={{
            display: "flex", alignItems: "center", gap: "24px",
            padding: "8px 24px 20px", position: "relative"
          }}>
            <div style={{ flexShrink: 0, width: "88px", height: "88px" }}>
              <style>{`@keyframes moonGlow {
                0% { filter: drop-shadow(0 0 15px rgba(255,220,120,0.25)) drop-shadow(0 0 35px rgba(255,200,80,0.1)); }
                100% { filter: drop-shadow(0 0 25px rgba(255,220,120,0.45)) drop-shadow(0 0 50px rgba(255,200,80,0.2)); }
              }`}</style>
              <MoonIllustration phase={phaseName} />
            </div>

            <div style={{ flex: 1 }}>
              <div style={{
                fontFamily: "Georgia, serif",
                fontSize: "18px",
                fontWeight: "400",
                color: "#f0e8c8",
                letterSpacing: "1.5px",
                marginBottom: "5px"
              }}>
                {phaseName}
              </div>
              <div style={{
                fontSize: "13px",
                fontStyle: "italic",
                color: "rgba(125, 211, 232, 0.8)",
                marginBottom: "10px"
              }}>
                {seasonEmoji[season]} {season}
              </div>
              <div style={{ fontSize: "11px", letterSpacing: "1px", color: "rgba(255,255,255,0.25)", textTransform: "uppercase" }}>
                Lunar Day {lunarDay} &nbsp;·&nbsp; {illumination}% illuminated
              </div>
            </div>
          </div>

          <div style={{
            borderTop: "1px solid rgba(125, 211, 232, 0.08)",
            padding: "12px 24px",
            fontFamily: "Georgia, serif",
            fontStyle: "italic",
            fontSize: "13px",
            color: "rgba(255,255,255,0.45)",
            lineHeight: "1.7",
            position: "relative"
          }}>
            {insight}
          </div>
        </>
      )}
    </div>
  );
}

function EntryDetail({ entry }) {
  const [insightsOpen, setInsightsOpen] = useState(true);

  const {
    title, content, session_date, created_at, category, state, subcategory,
    prompt_text, amount, method, time_of_day, session_timing,
    mood_before, mood_after, nervous_system_before, nervous_system_after,
    intention, intention_tags, intention_met, expected_effects, actual_effects,
    chakra_checkins, archetypal_themes, body_sensations,
  } = entry;

  const stateLabel = { Before: "Before Session", During: "During Session", After: "After Session" };
  const sessionParts = [amount, method, time_of_day, session_timing].filter(Boolean);
  const sessionDateFormatted = session_date
    ? new Date(session_date.replace(" ", "T")).toLocaleString('en-US', {
        year: 'numeric', month: 'long', day: 'numeric',
        hour: 'numeric', minute: '2-digit'
      })
    : null;
  const writtenDateFormatted = created_at
    ? new Date(created_at.replace(" ", "T")).toLocaleDateString()
    : null;
  const showWrittenDate = writtenDateFormatted &&
    writtenDateFormatted !== new Date(session_date.replace(" ", "T")).toLocaleDateString();

  const parsedChakras = Array.isArray(chakra_checkins)
    ? chakra_checkins : chakra_checkins ? JSON.parse(chakra_checkins) : [];
  const parsedBodySensations = Array.isArray(body_sensations)
    ? body_sensations : body_sensations ? JSON.parse(body_sensations) : [];
  const parsedThemes = archetypal_themes
    ? archetypal_themes.split(",").map(t => t.trim()).filter(Boolean) : [];
  const parsedIntentionTags = Array.isArray(intention_tags)
    ? intention_tags : intention_tags ? JSON.parse(intention_tags) : [];

  const formatEffects = (str) => str ? str.split(",").map(e => e.trim()).join(", ") : "";

  const nsBefore = NS_SCALE[nervous_system_before] || null;
  const nsAfter = NS_SCALE[nervous_system_after] || null;
  const nsDelta = nsBefore && nsAfter ? nsAfter - nsBefore : null;
  const moodBeforeInt = mood_before ? parseInt(mood_before) : null;
  const moodAfterInt = mood_after ? parseInt(mood_after) : null;
  const moodDelta = moodBeforeInt && moodAfterInt ? moodAfterInt - moodBeforeInt : null;
  const hasInsights = nsDelta !== null || moodDelta !== null || intention_met;
  const hasMindBody = parsedChakras.length > 0 || parsedThemes.length > 0 || parsedBodySensations.length > 0;

  const deltaColor = (d) => d > 0 ? "#7dd3e8" : d < 0 ? "#ff9a9a" : "rgba(255,255,255,0.5)";
  const deltaPrefix = (d) => d > 0 ? "+" : "";

  const cardStyle = {
    background: "rgba(255,255,255,0.05)",
    borderRadius: "10px",
    borderLeft: "3px solid rgba(125, 211, 232, 0.4)",
    padding: "14px 18px",
    marginBottom: "20px",
    fontSize: "13px"
  };

  return (
    <article className="EntryDetail">

      <div style={{ marginBottom: "20px" }}>
        <h1 style={{ margin: 0, fontSize: "24px", fontWeight: "500" }}>{title || "Untitled"}</h1>
      </div>

      <div style={{ ...cardStyle, display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
        <div>
          {(subcategory || category || state) && (
            <div style={{ fontWeight: "500", fontSize: "15px", marginBottom: "8px" }}>
              {subcategory && <span>{subcategory}</span>}
              {category && <span style={{ opacity: 0.9, marginLeft: "8px", fontSize: "13px" }}>{category}</span>}
              {state && (
                <span style={{
                  marginLeft: "10px", fontSize: "12px", opacity: 0.9,
                  background: "rgba(125, 211, 232, 0.15)", padding: "2px 8px",
                  borderRadius: "12px", border: "1px solid rgba(125, 211, 232, 0.3)"
                }}>
                  {stateLabel[state] || state}
                </span>
              )}
            </div>
          )}
          <div style={{ opacity: 0.9, marginBottom: "4px" }}>
            {sessionDateFormatted && <span>{sessionDateFormatted}</span>}
            {showWrittenDate && (
              <span style={{ marginLeft: "12px" }}>
                Written: {new Date(created_at.replace(" ", "T")).toLocaleString('en-US', {
                  year: 'numeric', month: 'long', day: 'numeric',
                  hour: 'numeric', minute: '2-digit'
                })}
              </span>
            )}
          </div>
          {sessionParts.length > 0 && <div style={{ opacity: 0.9 }}>{sessionParts.join(" · ")}</div>}
        </div>

        <div>
          {(mood_before || mood_after) && (
            <div style={{ opacity: 0.9, marginBottom: "6px" }}>
              <span style={{ marginRight: "6px" }}>Mood:</span>
              {mood_before && <span>before {mood_before}/5</span>}
              {mood_before && mood_after && <span style={{ margin: "0 6px" }}>→</span>}
              {mood_after && <span>after {mood_after}/5</span>}
            </div>
          )}
          {intention && (
            <div style={{ opacity: 0.85, fontStyle: "italic", marginBottom: "6px" }}>"{intention}"</div>
          )}
          {intention_met && (
            <div style={{ opacity: 0.9, marginBottom: "6px" }}>
              <span style={{ marginRight: "6px" }}>Intention Met:</span>{intention_met}/5
            </div>
          )}
          {expected_effects && (
            <div style={{ opacity: 0.9, marginBottom: "6px" }}>
              <span style={{ marginRight: "6px" }}>Expected:</span>{formatEffects(expected_effects)}
            </div>
          )}
          {actual_effects && (
            <div style={{ opacity: 0.9 }}>
              <span style={{ marginRight: "6px" }}>Actual:</span>{formatEffects(actual_effects)}
            </div>
          )}
        </div>
      </div>

      {parsedIntentionTags.length > 0 && (
        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", marginBottom: "12px" }}>
          <span style={{ fontSize: "12px", letterSpacing: "1px", marginRight: "2px" }}>Intentions:</span>
          {parsedIntentionTags.map(tag => (
            <span key={tag} style={{
              fontSize: "12px", padding: "2px 10px", borderRadius: "12px",
              background: "rgba(255, 170, 51, 0.1)", border: "1px solid rgba(255, 170, 51, 0.3)",
              color: "#ffaa33"
            }}>
              {tag}
            </span>
          ))}
        </div>
      )}

      <MoonCard sessionDate={session_date} />

      {hasInsights && (
        <div style={{
          background: "rgba(125, 211, 232, 0.05)",
          border: "1px solid rgba(125, 211, 232, 0.15)",
          borderRadius: "10px", marginBottom: "12px", overflow: "hidden"
        }}>
          <div
            onClick={() => setInsightsOpen(prev => !prev)}
            style={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              padding: "12px 16px", cursor: "pointer", userSelect: "none"
            }}
          >
            <span style={{ fontSize: "12px", letterSpacing: "1.5px", textTransform: "uppercase", color: "#7dd3e8", opacity: 0.85 }}>
              ✦ Session Insights
            </span>
            <span style={{
              fontSize: "11px", opacity: 0.5,
              transform: insightsOpen ? "rotate(0deg)" : "rotate(-90deg)",
              transition: "transform 0.2s", display: "inline-block"
            }}>▼</span>
          </div>
          {insightsOpen && (
            <div style={{ padding: "4px 16px 16px", display: "flex", flexDirection: "column", gap: "10px" }}>
              {nsDelta !== null && (
                <div style={{ fontSize: "13px" }}>
                  <span style={{ opacity: 0.75, marginRight: "8px" }}>🧠 Nervous System:</span>
                  <span>{nervous_system_before}</span>
                  <span style={{ margin: "0 6px", opacity: 0.75 }}>→</span>
                  <span>{nervous_system_after}</span>
                  <span style={{ marginLeft: "10px", color: deltaColor(nsDelta), fontWeight: "500" }}>
                    ({deltaPrefix(nsDelta)}{nsDelta})
                  </span>
                  <span style={{ marginLeft: "8px", opacity: 0.75, fontSize: "12px" }}>
                    — {regulationDeltaLabel(nsDelta)}
                  </span>
                </div>
              )}
              {moodDelta !== null && (
                <div style={{ fontSize: "13px" }}>
                  <span style={{ opacity: 0.75, marginRight: "8px" }}>😌 Mood:</span>
                  <span>{moodBeforeInt}/5</span>
                  <span style={{ margin: "0 6px", opacity: 0.75 }}>→</span>
                  <span>{moodAfterInt}/5</span>
                  <span style={{ marginLeft: "10px", color: deltaColor(moodDelta), fontWeight: "500" }}>
                    ({deltaPrefix(moodDelta)}{moodDelta})
                  </span>
                  <span style={{ marginLeft: "8px", opacity: 0.75, fontSize: "12px" }}>
                    — {moodDeltaLabel(moodDelta)}
                  </span>
                </div>
              )}
              {intention_met && (
                <div style={{ fontSize: "13px" }}>
                  <span style={{ opacity: 0.75, marginRight: "8px" }}>🎯 Intention Met:</span>
                  <span style={{ fontWeight: "500" }}>{intention_met}/5</span>
                  <span style={{ marginLeft: "8px", opacity: 0.75, fontSize: "12px" }}>
                    — {intentionMetLabel(intention_met)}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {hasMindBody && (
        <CollapsiblePills title="Mind & Body" open={true}>
          {parsedChakras.length > 0 && (
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
              <span style={{ fontSize: "12px", letterSpacing: "1px", marginRight: "2px", opacity: 0.75 }}>Chakras:</span>
              {parsedChakras.map(c => (
                <span key={c.chakra_id} style={{
                  fontSize: "12px", padding: "2px 10px", borderRadius: "12px",
                  background: "rgba(125, 211, 232, 0.1)", border: "1px solid rgba(125, 211, 232, 0.3)"
                }}>
                  {c.name}{c.state && <span style={{ opacity: 0.75, marginLeft: "4px" }}>— {c.state}</span>}
                </span>
              ))}
            </div>
          )}
          {parsedThemes.length > 0 && (
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
              <span style={{ fontSize: "12px", letterSpacing: "1px", marginRight: "2px", opacity: 0.75 }}>Themes:</span>
              {parsedThemes.map(theme => (
                <span key={theme} style={{
                  fontSize: "12px", padding: "2px 10px", borderRadius: "12px",
                  background: "rgba(180, 125, 232, 0.1)", border: "1px solid rgba(180, 125, 232, 0.3)",
                  color: "#b47de8"
                }}>
                  {theme}
                </span>
              ))}
            </div>
          )}
          {parsedBodySensations.length > 0 && (
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
              <span style={{ fontSize: "12px", letterSpacing: "1px", marginRight: "2px", opacity: 0.75 }}>Body:</span>
              {parsedBodySensations.map(s => (
                <span key={s.region} style={{
                  fontSize: "12px", padding: "2px 10px", borderRadius: "12px",
                  background: "rgba(235, 176, 113, 0.1)", border: "1px solid rgba(232, 180, 125, 0.3)",
                  color: "#ffaa33"
                }}>
                  {s.label}{s.sensation && <span style={{ opacity: 0.75, marginLeft: "4px" }}>— {s.sensation}</span>}
                </span>
              ))}
            </div>
          )}
        </CollapsiblePills>
      )}

      {prompt_text && (
        <div style={{ marginBottom: "24px", marginTop: "4px" }}>
          <span style={{ fontSize: "12px", opacity: 0.9, marginRight: "8px" }}>Prompt:</span>
          <div style={{
            borderLeft: "2px solid rgba(125, 211, 232, 0.4)",
            paddingLeft: "12px", marginTop: "6px",
            fontStyle: "italic", fontSize: "14px", opacity: 0.8
          }}>
            {prompt_text}
          </div>
        </div>
      )}

      <hr style={{ border: "none", borderTop: "1px solid rgba(255,255,255,0.1)", marginBottom: "20px" }} />

      <p style={{ lineHeight: "1.8", fontSize: "15px", whiteSpace: "pre-wrap" }}>{content}</p>

    </article>
  );
}

export default EntryDetail;*/

import { useState, useEffect } from "react";
import client from "../api/client";
import { useSettings } from "../context/SettingsContext";

const NS_SCALE = { Dysregulated: 1, Anxious: 2, Neutral: 3, Grounded: 4, Regulated: 5 };


function regulationDeltaLabel(delta) {
  if (delta >= 2) return "Strong positive shift";
  if (delta >= 1) return "Positive shift";
  if (delta > 0) return "Slight improvement";
  if (delta === 0) return "No change";
  if (delta >= -1) return "Slight decline";
  return "Significant decline";
}

function moodDeltaLabel(delta, medicine_type) {
  const isMushroom = medicine_type === "mushroom";

  if (delta >= 2) return "Strong improvement";
  if (delta >= 1) return "Improved";
  if (delta > 0) return "Slight improvement";
  if (delta === 0) return "No change";

  // Negative deltas
  if (delta >= -1) {
    return isMushroom ? "Lower expressed mood" : "Slight decline";
  }

  return isMushroom ? "Shift toward introspection" : "Significant decline";
}

function intentionMetLabel(val) {
  const labels = { 1: "Not at all", 2: "Slightly", 3: "Somewhat", 4: "Mostly", 5: "Fully" };
  return labels[parseInt(val)] || "";
}

function CollapsiblePills({ title, open: defaultOpen, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{
      background: "rgba(255,255,255,0.03)",
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "10px",
      marginBottom: "12px",
      overflow: "hidden"
    }}>
      <div
        onClick={() => setOpen(prev => !prev)}
        style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          padding: "10px 14px", cursor: "pointer", userSelect: "none"
        }}
      >
        <span style={{ fontSize: "11px", letterSpacing: "1.5px", textTransform: "uppercase", color: "#7dd3e8", opacity: 0.8 }}>
          ✦ {title}
        </span>
        <span style={{
          fontSize: "10px", opacity: 0.4,
          transform: open ? "rotate(0deg)" : "rotate(-90deg)",
          transition: "transform 0.2s", display: "inline-block"
        }}>▼</span>
      </div>
      {open && (
        <div style={{ padding: "0 14px 12px", display: "flex", flexDirection: "column", gap: "8px" }}>
          {children}
        </div>
      )}
    </div>
  );
}

function MoonIllustration({ phase }) {
  const defs = (
    <defs>
      <radialGradient id="moonGrad" cx="40%" cy="35%" r="60%">
        <stop offset="0%" stopColor="#fff8e0"/>
        <stop offset="40%" stopColor="#f0d878"/>
        <stop offset="100%" stopColor="#c8a840"/>
      </radialGradient>
      <radialGradient id="crater1" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="rgba(0,0,0,0.15)"/>
        <stop offset="100%" stopColor="rgba(0,0,0,0)"/>
      </radialGradient>
      <radialGradient id="darkSide" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#0d1628"/>
        <stop offset="100%" stopColor="#0a1020"/>
      </radialGradient>
    </defs>
  );

  const craters = (clipId) => (
    <g clipPath={`url(#${clipId})`}>
      <circle cx="58" cy="35" r="6" fill="url(#crater1)"/>
      <circle cx="42" cy="55" r="4" fill="url(#crater1)"/>
      <circle cx="65" cy="58" r="3" fill="url(#crater1)"/>
      <circle cx="50" cy="70" r="5" fill="url(#crater1)"/>
      <circle cx="35" cy="40" r="3" fill="url(#crater1)"/>
    </g>
  );

  const glowStyle = {
    filter: "drop-shadow(0 0 18px rgba(255, 220, 120, 0.35)) drop-shadow(0 0 40px rgba(255, 200, 80, 0.15))",
    animation: "moonGlow 4s ease-in-out infinite alternate"
  };

  const darkGlowStyle = {
    filter: "drop-shadow(0 0 8px rgba(125, 211, 232, 0.1))",
  };

  const svgProps = { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%" };

  switch (phase) {
    case 'New Moon':
      return (
        <svg {...svgProps} style={darkGlowStyle}>
          {defs}
          <circle cx="50" cy="50" r="45" fill="url(#darkSide)"/>
          <circle cx="50" cy="50" r="45" fill="none" stroke="rgba(125,211,232,0.15)" strokeWidth="0.5"/>
        </svg>
      );
    case 'Waxing Crescent':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs><clipPath id="wcClip"><path d="M50,5 A45,45 0 1,1 50,95 Q20,75 20,50 Q20,25 50,5 Z"/></clipPath></defs>
          <circle cx="50" cy="50" r="45" fill="#0d1628"/>
          <path d="M50,5 A45,45 0 1,1 50,95 Q20,75 20,50 Q20,25 50,5 Z" fill="url(#moonGrad)"/>
          {craters("wcClip")}
        </svg>
      );
    case 'First Quarter':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs><clipPath id="fqClip"><path d="M50,5 A45,45 0 0,1 50,95 L50,5 Z"/></clipPath></defs>
          <circle cx="50" cy="50" r="45" fill="#0d1628"/>
          <path d="M50,5 A45,45 0 0,1 50,95 L50,5 Z" fill="url(#moonGrad)"/>
          {craters("fqClip")}
        </svg>
      );
    case 'Waxing Gibbous':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs><clipPath id="wgClip"><path d="M50,5 A45,45 0 1,1 50,95 Q30,75 30,50 Q30,25 50,5 Z"/></clipPath></defs>
          <circle cx="50" cy="50" r="45" fill="#0d1628"/>
          <path d="M50,5 A45,45 0 1,1 50,95 Q30,75 30,50 Q30,25 50,5 Z" fill="url(#moonGrad)"/>
          {craters("wgClip")}
        </svg>
      );
    case 'Full Moon':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs><clipPath id="fmClip"><circle cx="50" cy="50" r="45"/></clipPath></defs>
          <circle cx="50" cy="50" r="45" fill="url(#moonGrad)"/>
          {craters("fmClip")}
        </svg>
      );
    case 'Waning Gibbous':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs><clipPath id="wanGibClip"><path d="M50,5 A45,45 0 1,0 50,95 Q70,75 70,50 Q70,25 50,5 Z"/></clipPath></defs>
          <circle cx="50" cy="50" r="45" fill="#0d1628"/>
          <path d="M50,5 A45,45 0 1,0 50,95 Q70,75 70,50 Q70,25 50,5 Z" fill="url(#moonGrad)"/>
          {craters("wanGibClip")}
        </svg>
      );
    case 'Last Quarter':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs><clipPath id="lqClip"><path d="M50,5 A45,45 0 0,0 50,95 L50,5 Z"/></clipPath></defs>
          <circle cx="50" cy="50" r="45" fill="#0d1628"/>
          <path d="M50,5 A45,45 0 0,0 50,95 L50,5 Z" fill="url(#moonGrad)"/>
          {craters("lqClip")}
        </svg>
      );
    case 'Waning Crescent':
      return (
        <svg {...svgProps} style={glowStyle}>
          {defs}
          <defs><clipPath id="wanCresClip"><path d="M50,5 A45,45 0 1,0 50,95 Q80,75 80,50 Q80,25 50,5 Z"/></clipPath></defs>
          <circle cx="50" cy="50" r="45" fill="#0d1628"/>
          <path d="M50,5 A45,45 0 1,0 50,95 Q80,75 80,50 Q80,25 50,5 Z" fill="url(#moonGrad)"/>
          {craters("wanCresClip")}
        </svg>
      );
    default:
      return null;
  }
}

function MoonCard({ sessionDate }) {
  const [moonData, setMoonData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!sessionDate) return;
    client.get('/moon', { params: { date: sessionDate } })
      .then(res => setMoonData(res.data))
      .catch(() => setMoonData(null));
  }, [sessionDate]);

  if (!moonData) return null;

  const { phaseName, illumination, lunarDay, season, insight } = moonData;
  const seasonEmoji = { Spring: "🌱", Summer: "☀️", Autumn: "🍂", Winter: "❄️" };

  return (
    <div style={{
      background: "linear-gradient(160deg, #0d1f3a 0%, #0a1628 50%, #0d1a2e 100%)",
      border: "1px solid rgba(125, 211, 232, 0.15)",
      borderRadius: "16px",
      overflow: "hidden",
      marginBottom: "16px",
      position: "relative"
    }}>
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden" }}>
        {Array.from({ length: 28 }).map((_, i) => (
          <div key={i} style={{
            position: "absolute",
            width: `${Math.random() * 1.5 + 0.5}px`,
            height: `${Math.random() * 1.5 + 0.5}px`,
            borderRadius: "50%",
            background: "white",
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            opacity: Math.random() * 0.5 + 0.1,
          }}/>
        ))}
      </div>

      <div
        onClick={() => setOpen(prev => !prev)}
        style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          padding: "12px 20px", cursor: "pointer", userSelect: "none", position: "relative"
        }}
      >
        <span style={{ fontSize: "11px", letterSpacing: "1.5px", textTransform: "uppercase", color: "#7dd3e8", opacity: 0.8 }}>
          ✦ Celestial Context
        </span>
        <span style={{
          fontSize: "10px", opacity: 0.4,
          transform: open ? "rotate(0deg)" : "rotate(-90deg)",
          transition: "transform 0.2s", display: "inline-block"
        }}>▼</span>
      </div>

      {open && (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: "24px", padding: "8px 24px 20px", position: "relative" }}>
            <div style={{ flexShrink: 0, width: "88px", height: "88px" }}>
              <style>{`@keyframes moonGlow {
                0% { filter: drop-shadow(0 0 15px rgba(255,220,120,0.25)) drop-shadow(0 0 35px rgba(255,200,80,0.1)); }
                100% { filter: drop-shadow(0 0 25px rgba(255,220,120,0.45)) drop-shadow(0 0 50px rgba(255,200,80,0.2)); }
              }`}</style>
              <MoonIllustration phase={phaseName} />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontFamily: "Georgia, serif", fontSize: "18px", fontWeight: "400", color: "#f0e8c8", letterSpacing: "1.5px", marginBottom: "5px" }}>
                {phaseName}
              </div>
              <div style={{ fontSize: "13px", fontStyle: "italic", color: "rgba(125, 211, 232, 0.8)", marginBottom: "10px" }}>
                {seasonEmoji[season]} {season}
              </div>
              <div style={{ fontSize: "11px", letterSpacing: "1px", color: "rgba(255,255,255,0.25)", textTransform: "uppercase" }}>
                Lunar Day {lunarDay} &nbsp;·&nbsp; {illumination}% illuminated
              </div>
            </div>
          </div>
          <div style={{
            borderTop: "1px solid rgba(125, 211, 232, 0.08)",
            padding: "12px 24px",
            fontFamily: "Georgia, serif",
            fontStyle: "italic",
            fontSize: "13px",
            color: "rgba(255,255,255,0.45)",
            lineHeight: "1.7",
            position: "relative"
          }}>
            {insight}
          </div>
        </>
      )}
    </div>
  );
}

function EntryDetail({ entry, guidedSession }) {
  const [insightsOpen, setInsightsOpen] = useState(false);
  const { settings } = useSettings();

  const {
    title, content, session_date, created_at, category, state, subcategory,
    prompt_text, amount, method, time_of_day, session_timing,
    mood_before, mood_after, nervous_system_before, nervous_system_after,
    intention, intention_tags, intention_met, expected_effects, actual_effects,
    chakra_checkins, archetypal_themes, body_sensations, medicine_type,
  } = entry;

  const stateLabel = { Before: "Before Session", During: "During Session", After: "After Session" };
  const sessionParts = [amount, method, time_of_day, session_timing].filter(Boolean);
  const sessionDateFormatted = session_date
    ? new Date(session_date.replace(" ", "T")).toLocaleString('en-US', {
        year: 'numeric', month: 'long', day: 'numeric',
        hour: 'numeric', minute: '2-digit'
      })
    : null;
  const writtenDateFormatted = created_at
    ? new Date(created_at.replace(" ", "T")).toLocaleDateString()
    : null;
  const showWrittenDate = writtenDateFormatted &&
    writtenDateFormatted !== new Date(session_date.replace(" ", "T")).toLocaleDateString();

  const parsedChakras = Array.isArray(chakra_checkins)
    ? chakra_checkins : chakra_checkins ? JSON.parse(chakra_checkins) : [];
  const parsedBodySensations = Array.isArray(body_sensations)
    ? body_sensations : body_sensations ? JSON.parse(body_sensations) : [];
  const parsedThemes = archetypal_themes
    ? archetypal_themes.split(",").map(t => t.trim()).filter(Boolean) : [];
  const parsedIntentionTags = Array.isArray(intention_tags)
    ? intention_tags : intention_tags ? JSON.parse(intention_tags) : [];

  const formatEffects = (str) => str ? str.split(",").map(e => e.trim()).join(", ") : "";

  const nsBefore = NS_SCALE[nervous_system_before] || null;
  const nsAfter = NS_SCALE[nervous_system_after] || null;
  const nsDelta = nsBefore && nsAfter ? nsAfter - nsBefore : null;
  const moodBeforeInt = mood_before ? parseInt(mood_before) : null;
  const moodAfterInt = mood_after ? parseInt(mood_after) : null;
  const moodDelta = moodBeforeInt && moodAfterInt ? moodAfterInt - moodBeforeInt : null;
  const hasInsights = nsDelta !== null || moodDelta !== null || intention_met;
  const hasMindBody = parsedChakras.length > 0 || parsedThemes.length > 0 || parsedBodySensations.length > 0;

  const deltaColor = (d) => d > 0 ? "#7dd3e8" : d < 0 ? "#ff9a9a" : "rgba(255,255,255,0.5)";
  const deltaPrefix = (d) => d > 0 ? "+" : "";

  const cardStyle = {
    background: "rgba(255,255,255,0.05)",
    borderRadius: "10px",
    borderLeft: "3px solid rgba(125, 211, 232, 0.4)",
    padding: "14px 18px",
    marginBottom: "20px",
    fontSize: "13px"
  };

  const handleViewTranscript = () => {
    if (!guidedSession?.token) return;
      window.open(`/sitter/${guidedSession.token}`, '_blank');
  };

  const sessionInProgress = guidedSession && !guidedSession.ended_at;

  return (
    <article className="EntryDetail">

      {/* TITLE */}
      <div style={{ marginBottom: "20px" }}>
        <h1 style={{ margin: 0, fontSize: "24px", fontWeight: "500" }}>{title || "Untitled"}</h1>
      </div>


      {/* SESSION CARD */}
      <div
  style={{
    ...cardStyle,
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    overflow: "hidden",
  }}
>

      {/* BACKGROUND ILLUSTRATION */}
      {(medicine_type === "cannabis" || medicine_type === "weed") && (
    <svg xmlns="http://www.w3.org/2000/svg" width="120" height="150" viewBox="0 0 180 220" fill="none" aria-hidden="true" 
         style={{ position: "absolute", top: "-10px", right: "-10px", opacity: 0.75, pointerEvents: "none", transform: "rotate(12deg)" }}>
      <g opacity="0.85">
        <defs>
          <linearGradient id="leafGreen" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#5fbf6a"/><stop offset="45%" stop-color="#3a8f54"/><stop offset="100%" stop-color="#1f4d2f"/></linearGradient>
          <linearGradient id="budGreen" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#7acb82"/><stop offset="45%" stop-color="#3f8f57"/><stop offset="100%" stop-color="#1f4d32"/></linearGradient>
          <linearGradient id="stemGreen" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#2a6b3d"/><stop offset="100%" stop-color="#1c4a2b"/></linearGradient>
          <radialGradient id="trichome" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#ffffff" stop-opacity="0.3"/><stop offset="100%" stop-color="#dffcff" stop-opacity="0"/></radialGradient>
        </defs>
        <path d="M90 210 C90 179 90 159 90 137" stroke="url(#stemGreen)" stroke-width="4" stroke-linecap="round"/>
        <path d="M90 145 C73 132 61 114 56 96 C71 98 84 104 95 114 C96 97 102 80 113 65 C120 81 120 98 115 114 C130 108 146 106 162 109 C149 122 135 130 119 134 C127 151 132 168 131 185 C119 174 109 159 102 143 C99 157 92 173 81 188 C79 171 82 156 88 141 C73 144 56 141 42 133 C56 126 69 121 82 119 C76 101 75 83 79 66 C88 78 93 92 94 107 C99 91 107 77 119 66 C121 83 119 100 112 116 C128 117 143 123 156 134 C141 141 125 145 109 145 C109 160 106 176 99 192 C92 178 89 162 90 145 Z" fill="url(#leafGreen)" stroke="#163822" stroke-width="1.2" stroke-linejoin="round"/>
        <path d="M90 86 C83 80 78 72 77 64 C84 65 89 68 93 74 C96 68 101 64 107 61 C106 69 102 75 96 79 C100 83 103 88 103 94 C98 92 94 88 92 83 C90 88 86 92 81 95 C80 89 83 84 87 81 C82 79 77 75 73 69 C80 69 85 72 89 76 C90 71 92 67 94 63 C96 67 98 71 99 76 C103 72 108 69 114 69 C111 75 106 80 101 82 C104 86 106 91 106 97 C101 95 97 91 95 86 C93 91 89 95 84 98 C84 92 86 88 90 86 Z" fill="url(#budGreen)" stroke="#1b4a2e" stroke-width="1" stroke-linejoin="round"/>
        <path d="M90 118 C82 112 76 103 73 93 C81 94 88 98 94 104 C96 95 100 87 107 80 C110 89 109 98 106 106 C114 102 123 100 132 101 C126 109 118 115 109 118 C113 127 116 136 116 145 C109 139 103 131 99 122 C96 131 90 140 82 148 C81 138 83 128 88 119 C79 120 71 119 63 115 C71 110 79 107 86 106 C84 98 84 91 86 84 C90 90 92 97 93 104 C95 98 99 91 105 85 C107 92 106 99 103 105 C111 106 119 109 126 114 C118 118 110 120 102 120 C101 129 99 138 94 146 C90 137 88 128 90 118 Z" fill="url(#budGreen)" stroke="#1b4a2e" stroke-width="1" stroke-linejoin="round" opacity="0.98"/>
        <path d="M90 44 C86 42 83 38 82 33 C86 34 90 35 93 39 C96 35 100 33 104 32 C103 37 100 41 96 43 C98 46 100 49 100 54 C96 52 93 50 91 46 C89 50 86 53 82 55 C82 50 84 46 88 44 C84 43 80 40 77 36 C82 36 86 38 89 41 C90 37 91 34 93 31 C95 34 96 37 97 41 C100 38 103 36 108 36 C105 40 102 43 98 44 C100 47 102 50 102 55 C98 53 95 50 93 44 C91 50 88 53 84 56 C84 50 86 46 90 44 Z" fill="url(#budGreen)" stroke="#1b4a2e" stroke-width="1" stroke-linejoin="round"/>
        <circle cx="84" cy="36" r="1.8" fill="url(#trichome)"/><circle cx="91" cy="35" r="1.6" fill="url(#trichome)"/><circle cx="98" cy="37" r="1.7" fill="url(#trichome)"/><circle cx="88" cy="49" r="1.4" fill="url(#trichome)"/><circle cx="96" cy="49" r="1.4" fill="url(#trichome)"/><circle cx="78" cy="70" r="1.5" fill="url(#trichome)"/><circle cx="104" cy="70" r="1.5" fill="url(#trichome)"/><circle cx="70" cy="103" r="1.5" fill="url(#trichome)"/><circle cx="112" cy="103" r="1.5" fill="url(#trichome)"/><circle cx="78" cy="126" r="1.4" fill="url(#trichome)"/><circle cx="102" cy="126" r="1.4" fill="url(#trichome)"/><circle cx="90" cy="56" r="1.2" fill="url(#trichome)"/><circle cx="93" cy="96" r="1.2" fill="url(#trichome)"/>
        <path d="M90 145 C90 130 90 114 90 98" stroke="#245b34" stroke-width="1" stroke-linecap="round" opacity="0.7"/>
      </g>
    </svg>
  )}

  {/* Mushroom */}
  {(medicine_type === "mushroom" || medicine_type === "psilocybin") && (
    <svg xmlns="http://www.w3.org/2000/svg" width="120" height="140" viewBox="0 0 120 140" fill="none" aria-hidden="true" 
         style={{ position: "absolute", top: "-10px", right: "-10px", opacity: 0.45, pointerEvents: "none", transform: "rotate(12deg)" }}>
      <g opacity="0.9">
        <defs>
          <linearGradient id="capGradient" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#e6b85c"/><stop offset="50%" stop-color="#d49d3d"/><stop offset="100%" stop-color="#a87522"/></linearGradient>
          <linearGradient id="stemGradient" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#f5e6c8"/><stop offset="50%" stop-color="#e3d0ab"/><stop offset="100%" stop-color="#d6c196"/></linearGradient>
          <radialGradient id="gillGradient" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#c4b59d" stop-opacity="0.8"/><stop offset="100%" stop-color="#b0a085" stop-opacity="0.3"/></radialGradient>
        </defs>
        <path d="M55 135 C55 110 56 85 58 70 C62 70 63 70 67 70 C69 85 70 110 70 135 Z" fill="url(#stemGradient)" stroke="#b8a682" stroke-width="1.2"/>
        <path d="M57 72 C57 78 68 78 68 72 C62 74 62 74 57 72 Z" fill="url(#gillGradient)" />
        <path d="M30 75 C30 40 55 15 62 15 C82 15 110 40 110 75 C95 65 75 65 62 65 C45 65 40 65 30 75 Z" fill="url(#capGradient)" stroke="#8c5e1a" stroke-width="1.2" stroke-linejoin="round"/>
        <circle cx="55" cy="35" r="3" fill="#fdf0d5" fill-opacity="0.4"/><circle cx="85" cy="40" r="3" fill="#fdf0d5" fill-opacity="0.3"/>
        <path d="M60 20 C60 12 75 12 75 20 C75 28 60 28 60 20 Z" fill="#c98a28" fill-opacity="0.6"/>
      </g>
    </svg>
  )}



  <div
  style={{
    position: "relative",
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
    gap: "16px",
    overflow: "hidden",
    alignItems: "start",
    justifyContent: "start"
  }}
>
  {/* Column 1 */}
  <div style={{ display: "flex", flexDirection: "column", gap: "8px", minWidth: 0 }}>
    {(subcategory || category || state) && (
      <div style={{ fontWeight: "500", fontSize: "15px", marginBottom: "8px" }}>
        {subcategory && <span>{subcategory}</span>}
        {category && <span style={{ opacity: 0.9, marginLeft: "8px", fontSize: "13px" }}>{category}</span>}
        {state && (
          <span style={{
            marginLeft: "10px", fontSize: "12px", opacity: 0.9,
            background: "rgba(125, 211, 232, 0.15)", padding: "2px 8px",
            borderRadius: "12px", border: "1px solid rgba(125, 211, 232, 0.3)"
          }}>
            {stateLabel[state] || state}
          </span>
        )}
      </div>
    )}
    
    <div style={{ opacity: 0.9, marginBottom: "4px" }}>
      {sessionDateFormatted && <span>{sessionDateFormatted}</span>}
      {showWrittenDate && (
        <span style={{ marginLeft: "12px" }}>
          Written: {new Date(created_at.replace(" ", "T")).toLocaleString('en-US', {
            year: 'numeric', month: 'long', day: 'numeric',
            hour: 'numeric', minute: '2-digit'
          })}
        </span>
      )}
    </div>
    
    {sessionParts.length > 0 && <div style={{ opacity: 0.9 }}>{sessionParts.join(" · ")}</div>}
  </div>

  {/* Column 2 */}
  <div style={{ display: "flex", flexDirection: "column", gap: "8px",  alignItems: "flex-start", minWidth:0, maxWidth:"320px" }}>
    {(mood_before || mood_after) && (
      <div style={{ opacity: 0.9, marginBottom: "6px" }}>
        <span style={{ marginRight: "6px" }}>Mood:</span>
        {mood_before && <span>before {mood_before}/5</span>}
        {mood_before && mood_after && <span style={{ margin: "0 6px" }}>→</span>}
        {mood_after && <span>after {mood_after}/5</span>}
      </div>
    )}

    {intention && (
      <div
        style={{
          opacity: 0.85,
          fontStyle: "italic",
          marginBottom: "6px",
          width: "100%",
          display: "block",
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          wordBreak: "break-word"
        }}
      >
        "{intention}"
      </div>
    )}

    {intention_met && (
      <div style={{ opacity: 0.9, marginBottom: "6px" }}>
        <span style={{ marginRight: "6px" }}>Intention Met:</span>{intention_met}/5
      </div>
    )}
    {expected_effects && (
      <div style={{ opacity: 0.9, marginBottom: "6px" }}>
        <span style={{ marginRight: "6px" }}>Expected:</span>{formatEffects(expected_effects)}
      </div>
    )}
    {actual_effects && (
      <div style={{ opacity: 0.9 }}>
        <span style={{ marginRight: "6px" }}>Actual:</span>{formatEffects(actual_effects)}
      </div>
    )}
  </div>
</div>
</div>
{/* SESSION FLOW */}
{guidedSession && (
  <div style={{
    background: sessionInProgress
      ? "rgba(125, 211, 132, 0.07)"
      : "rgba(125, 211, 232, 0.07)",
    border: `1px solid ${sessionInProgress
      ? "rgba(125, 211, 132, 0.25)"
      : "rgba(125, 211, 232, 0.2)"}`,
    borderRadius: "10px",
    padding: "14px 18px",
    marginBottom: "20px",
    fontSize: "13px",
  }}>
    <div style={{
      fontWeight: 600,
      marginBottom: "6px",
      color: sessionInProgress ? "#7dd384" : "#7dd3e8"
    }}>
      {sessionInProgress ? "🧭 Session Flow In Progress" : "🧭 Session Flow"}
    </div>
    {sessionInProgress ? (
      <div style={{ opacity: 0.7 }}>
        A session flow is still active for this entry.
      </div>
    ) : (
      <>
        <div style={{ opacity: 0.7, marginBottom: "6px" }}>
          Session on {new Date(guidedSession.created_at).toLocaleDateString([], {
            weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
          })}
          {guidedSession.ended_at && ` · ended ${new Date(guidedSession.ended_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`}
        </div>
        {guidedSession.sitter_name && (
          <div style={{ opacity: 0.6, marginBottom: "4px" }}>
            Sitter: {guidedSession.sitter_name}
          </div>
        )}
        {guidedSession.messages?.length > 0 && (
  <span
    onClick={handleViewTranscript}
    style={{
      display: "inline-block",
      marginTop: "8px",
      fontSize: "12px",
      color: "#7dd3e8",
      cursor: "pointer",
      textDecoration: "underline",
      opacity: 0.85
    }}
  >
    View Chat Transcript ↗ 
  </span>
)}

{guidedSession.messages?.length === 0 && (
  <div style={{ opacity: 0.4, fontSize: "12px", marginTop: "6px" }}>
    {guidedSession.history_was_preserved
      ? "No chat messages were recorded."
      : "Chat history was not preserved for this session."}
  </div>
)}


        
      </>
    )}
  </div>
)}
      {/* INTENTIONS */}
      {parsedIntentionTags.length > 0 && (
        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", marginBottom: "12px" }}>
          <span style={{ fontSize: "12px", letterSpacing: "1px", marginRight: "2px" }}>Intentions:</span>
          {parsedIntentionTags.map(tag => (
            <span key={tag} style={{
              fontSize: "12px", padding: "2px 10px", borderRadius: "12px",
              background: "rgba(255, 170, 51, 0.1)", border: "1px solid rgba(255, 170, 51, 0.3)",
              color: "#ffaa33"
            }}>
              {tag}
            </span>
          ))}
        </div>
      )}

      {/* SESSION INSIGHTS */}
      {hasInsights && (
        <div style={{
          background: "rgba(125, 211, 232, 0.05)",
          border: "1px solid rgba(125, 211, 232, 0.15)",
          borderRadius: "10px", marginBottom: "12px", overflow: "hidden"
        }}>
          <div
            onClick={() => setInsightsOpen(prev => !prev)}
            style={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              padding: "12px 16px", cursor: "pointer", userSelect: "none"
            }}
          >
            <span style={{ fontSize: "12px", letterSpacing: "1.5px", textTransform: "uppercase", color: "#7dd3e8", opacity: 0.85 }}>
              ✦ Session Insights
            </span>
            <span style={{
              fontSize: "11px", opacity: 0.5,
              transform: insightsOpen ? "rotate(0deg)" : "rotate(-90deg)",
              transition: "transform 0.2s", display: "inline-block"
            }}>▼</span>
          </div>
          {insightsOpen && (
            <div style={{ padding: "4px 16px 16px", display: "flex", flexDirection: "column", gap: "10px" }}>
              {nsDelta !== null && (
                <div style={{ fontSize: "13px" }}>
                  <span style={{ opacity: 0.75, marginRight: "8px" }}>🧠 Nervous System:</span>
                  <span>{nervous_system_before}</span>
                  <span style={{ margin: "0 6px", opacity: 0.75 }}>→</span>
                  <span>{nervous_system_after}</span>
                  <span style={{ marginLeft: "10px", color: deltaColor(nsDelta), fontWeight: "500" }}>
                    ({deltaPrefix(nsDelta)}{nsDelta})
                  </span>
                  <span style={{ marginLeft: "8px", opacity: 0.75, fontSize: "12px" }}>
                    — {regulationDeltaLabel(nsDelta)}
                  </span>
                </div>
              )}
              {moodDelta !== null && (
                <div style={{ fontSize: "13px" }}>
                  <span style={{ opacity: 0.75, marginRight: "8px" }}>😌 Mood:</span>
                  <span>{moodBeforeInt}/5</span>
                  <span style={{ margin: "0 6px", opacity: 0.75 }}>→</span>
                  <span>{moodAfterInt}/5</span>
                  <span style={{ marginLeft: "10px", color: deltaColor(moodDelta), fontWeight: "500" }}>
                    ({deltaPrefix(moodDelta)}{moodDelta})
                  </span>
                  <span style={{ marginLeft: "8px", opacity: 0.75, fontSize: "12px" }}>
                    — {moodDeltaLabel(moodDelta, medicine_type)}
                  </span>
                </div>
              )}
              {intention_met && (
                <div style={{ fontSize: "13px" }}>
                  <span style={{ opacity: 0.75, marginRight: "8px" }}>🎯 Intention Met:</span>
                  <span style={{ fontWeight: "500" }}>{intention_met}/5</span>
                  <span style={{ marginLeft: "8px", opacity: 0.75, fontSize: "12px" }}>
                    — {intentionMetLabel(intention_met)}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* PROMPT */}
      {settings.show_prompt && prompt_text && (
        <div style={{ marginBottom: "24px", marginTop: "4px" }}>
          <span style={{ fontSize: "12px", opacity: 0.9, marginRight: "8px" }}>Prompt:</span>
          <div style={{
            borderLeft: "2px solid rgba(125, 211, 232, 0.4)",
            paddingLeft: "12px", marginTop: "6px",
            fontStyle: "italic", fontSize: "14px", opacity: 0.8
          }}>
            {prompt_text}
          </div>
        </div>
      )}

      {/* DIVIDER */}
      <hr style={{ border: "none", borderTop: "1px solid rgba(255,255,255,0.1)", marginBottom: "20px" }} />

      {/* CONTENT */}
      <div style={{ marginTop: "22px", paddingTop: "14px", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
    <span style={{ fontSize: "12px", letterSpacing: "0.12em", textTransform: "uppercase", opacity: 0.55 }}>
      — Journal Entry
    </span>
  </div>
</div>
      <p style={{ lineHeight: "1.8", fontSize: "15px", whiteSpace: "pre-wrap" }}>{content}</p>
      
      {/* MIND & BODY */}
      {settings.show_mind_body && hasMindBody && (
        <CollapsiblePills title="Mind & Body" open={true}>
          {parsedChakras.length > 0 && (
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
              <span style={{ fontSize: "12px", letterSpacing: "1px", marginRight: "2px", opacity: 0.75 }}>Chakras:</span>
              {parsedChakras.map(c => (
                <span key={c.chakra_id} style={{
                  fontSize: "12px", padding: "2px 10px", borderRadius: "12px",
                  background: "rgba(125, 211, 232, 0.1)", border: "1px solid rgba(125, 211, 232, 0.3)"
                }}>
                  {c.name}{c.state && <span style={{ opacity: 0.75, marginLeft: "4px" }}>— {c.state}</span>}
                </span>
              ))}
            </div>
          )}
          {parsedThemes.length > 0 && (
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
              <span style={{ fontSize: "12px", letterSpacing: "1px", marginRight: "2px", opacity: 0.75 }}>Themes:</span>
              {parsedThemes.map(theme => (
                <span key={theme} style={{
                  fontSize: "12px", padding: "2px 10px", borderRadius: "12px",
                  background: "rgba(180, 125, 232, 0.1)", border: "1px solid rgba(180, 125, 232, 0.3)",
                  color: "#b47de8"
                }}>
                  {theme}
                </span>
              ))}
            </div>
          )}
          {parsedBodySensations.length > 0 && (
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
              <span style={{ fontSize: "12px", letterSpacing: "1px", marginRight: "2px", opacity: 0.75 }}>Body:</span>
              {parsedBodySensations.map(s => (
                <span key={s.region} style={{
                  fontSize: "12px", padding: "2px 10px", borderRadius: "12px",
                  background: "rgba(235, 176, 113, 0.1)", border: "1px solid rgba(232, 180, 125, 0.3)",
                  color: "#ffaa33"
                }}>
                  {s.label}{s.sensation && <span style={{ opacity: 0.75, marginLeft: "4px" }}>— {s.sensation}</span>}
                </span>
              ))}
            </div>
          )}
        </CollapsiblePills>
      )}
      {/* MOON CARD */}
      {settings.show_celestial && <MoonCard sessionDate={session_date} />}
    </article>
  );
}

export default EntryDetail;